// ═══════════════════════════════════════════════════════════════════
// WILD WOMAN MILLIONS™ — GLOBAL EDIT POINTS
// Change values here and the whole page updates.
// ═══════════════════════════════════════════════════════════════════
export const site = {
  productName: "WILD WOMAN MILLIONS™",
  belief: "CLARITY IS CURRENCY™",
  method: "VISION → BLUEPRINT → QUANTUM HABITS → CAPACITY → CURRENCY™",
  tagline: "THE VISION EXPERIENCE BY DASHA LOVE",
  price: "$27",

  // Every CTA on the page points here. Swap the link in ONE place:
  checkoutUrl: "https://orgasmicoffers.com/vision",

  // Sales video — mp4 file, YouTube or Vimeo link both work:
  videoUrl: "https://youtu.be/YnI7Mi-F_pY",
  videoLabel: "A MINUTE WITH DASHA",
  videoCaption: "Your vision may not need more time. It may need a decision.",

  // Footer CONTACT link:
  instagramUrl: "https://www.instagram.com/dashaloveofficial/",

  // HERO BANNER — swap in ONE line. Files live in /public/assets/.
  // "hero-header.jpg" = Vision/Currency/Capacity collage (bus, beach, books)
  // "hero-top.jpg"    = $777 → $27 price version (family, tantra, freedom)
  // "hero-wild.jpg"   = Wild Woman Millions branded collage (leopard, bus, phones)
  // "hero-gold.jpg"   = Gold WWV collage (leopard, Love Bus, books, $27)
  heroBanner: "hero-millions.jpg",
};

// VALUE STACK — approved total value shown struck-through next to the $27 price.
export const normalPrice = "$777";
export const valueStack = [
  { label: "Wild Woman Millions™ — The Experience", value: "" },
  { label: "Paid For Being You — Million Dollar Momentum Planner", value: "" },
  { label: "Stop F*cking Hiding", value: "" },
  { label: "Becoming Her Blueprint", value: "" },
  { label: "Bonus: 7 Daily Rituals program", value: "" },
  { label: "Bonus: The Blueprint belief-shift program", value: "" },
];

export const books = [
  {
    img: "/assets/book-paid-for-being-you.jpg",
    title: "PAID FOR BEING YOU",
    sub: "Million Dollar Momentum Planner",
    desc: "The momentum planner that keeps your vision on paper and your next move in front of you — daily.",
  },
  {
    img: "/assets/book-stop-hiding.jpg",
    title: "STOP F*CKING HIDING",
    sub: "Awakening love through psychedelic integration",
    desc: "Stop holding back. Trust yourself. Live the life you actually want.",
  },
  {
    img: "/assets/book-becoming-her.jpg",
    title: "BECOMING HER BLUEPRINT",
    sub: "Become a badass who goes all in",
    desc: "Raise standards. Embody it. Protect energy. Build legacy. Live in alignment.",
  },
];

// The real contents of the 7 Daily Rituals / Quantum Habits program (from the members area):
export const habits = [
  { n: "01", title: "THE 7 DAILY RITUALS", desc: "The core daily practice the entire identity work is built on." },
  { n: "02", title: "ACCOUNTABILITY", desc: "The structure that keeps the rituals alive on ordinary days." },
  { n: "03", title: "INNER CHILD MEDITATION", desc: "Guided inner child work beneath the habits." },
  { n: "04", title: "RITUALS HYPNOSIS", desc: "Guided hypnosis to install the rituals deeper than willpower." },
  { n: "05", title: "PATTERN DISRUPTION MEDITATION", desc: "Interrupt the old loops the moment they start running." },
  { n: "06", title: "UNCONDITIONAL LOVE — RITE OF PASSAGE", desc: "The rite of passage at the heart of the work." },
  { n: "07", title: "DANCE — 7 DAILY RITUALS", desc: "Embodiment through movement — the vision practiced in the body." },
];

export const currencyWords = [
  "MONEY", "ENERGY", "ATTENTION", "TIME", "IDEAS", "CREATIVITY",
  "LOVE", "RELATIONSHIPS", "OPPORTUNITY", "IMPACT", "PLEASURE", "FREEDOM",
];
